module.exports = __webpack_public_path__ + "static/img/favicon.15ca17f.png";